import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 1,
  class: "flex-grow-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Preloader = _resolveComponent("Preloader")!
  const _component_LeftSidebar = _resolveComponent("LeftSidebar")!
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Preloader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSidebar && !_ctx.isNotFound)
      ? (_openBlock(), _createBlock(_component_LeftSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["main-content d-flex flex-column", { 'p-0': _ctx.shouldShowPaddingZero || _ctx.isNotFound }])
      }, [
        (_ctx.shouldShowHeader && !_ctx.isNotFound)
          ? (_openBlock(), _createBlock(_component_TopHeader, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view),
        (_ctx.shouldShowDiv && !_ctx.isNotFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.shouldShowFooter && !_ctx.isNotFound)
          ? (_openBlock(), _createBlock(_component_MainFooter, { key: 2 }))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}